import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

import Btn from '../../../components/Btn';
import '../../../grid.css';
import './smart.css';

class SMART extends Component {
    toggleSMARTIsVisible() {
        const { setSMARTisVisible, isVisible } = this.props;
        setSMARTisVisible(!isVisible);
    }

    handleSMARTValueChange(value) {
        const { setSMARTValue } = this.props;
        setSMARTValue(Number(value));
    }

    render() {
        const {
            smartValue, isVisible, isLocked,
        } = this.props;

        return (
            <div>
                <Btn label="SMART" onClick={(e, value) => this.toggleSMARTIsVisible(value)} />
                {isVisible ? (
                    <div className="row containerSGIP">
                        <div className="col span-1-of-4">
                            <TextField
                                hintText="8.00"
                                defaultValue={smartValue}
                                onChange={(e, value) =>
                                    this.handleSMARTValueChange(value)}
                                floatingLabelText="Incentive Rate $/kWh"
                                disabled={isLocked}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

SMART.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    setSMARTisVisible: PropTypes.func.isRequired,
    setSMARTValue: PropTypes.func.isRequired,
    smartValue: PropTypes.number.isRequired,
};

SMART.defaultProps = {};

export default SMART;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SMART/SMART.js